/**
 * Check if the style object has grid alignment properties
 * @param {Object} style - Current block styles
 * @return {boolean} True if the style object has grid alignment properties
 */
function checkGridAlignment(style) {
	return (
		style?.justifyContent ||
		style?.justifyItems ||
		style?.alignItems ||
		style?.alignContent
	);
}

/**
 * Convert vertical bar syntax to CSS variable
 * @param {string} string - Vertical bar syntax string
 * @return {string|undefined} CSS variable or undefined
 */
function convertVerticalBarSyntaxToCSS(string) {
	if (string === '0') return '0';
	if (!string || typeof string !== 'string') return undefined;
	if (!string.includes(':')) return string;

	const parts = string.split(':');
	if (parts.length < 2) return string;

	const val = parts[1].trim();
	return `var(--wp--${val.replaceAll('|', '--')})`;
}

/**
 * Get and convert the block styles to correct object
 * @param {Object} styleOrAttributes - Current block styles or attributes object
 * @return {Object} Block style object
 */
function getBlockStyles(styleOrAttributes) {
	const style = styleOrAttributes?.style || styleOrAttributes;

	const getSpacing = (type, side) => {
		const value = style?.spacing?.[type]?.[side] ?? style?.[type]?.[side];
		if (value === undefined || value === null) return undefined;
		return convertVerticalBarSyntaxToCSS(value);
	};

	return {
		background: style?.backgroundColor || style?.color?.background,
		marginTop: getSpacing('margin', 'top'),
		marginBottom: getSpacing('margin', 'bottom'),
		paddingTop: getSpacing('padding', 'top'),
		paddingBottom: getSpacing('padding', 'bottom'),
		paddingLeft: getSpacing('padding', 'left'),
		paddingRight: getSpacing('padding', 'right'),
		width: style?.width,
		height: style?.height,
		display: checkGridAlignment(style) ? 'grid' : undefined,
		justifyItems: style?.justifyItems,
		alignItems: style?.alignItems,
		alignContent: style?.alignContent,
		gap: style?.gap,
	};
}

export { getBlockStyles };
